import { LoggingManager, StockSymbol } from '@benzinga/session';

import { PriceAlerts } from '@benzinga/price-alert-manager';
import { DateTime } from 'luxon';

const sortAlertsOnDateCreatedDescending = (a: Partial<PriceAlerts.Alert>, b: Partial<PriceAlerts.Alert>) => {
  return DateTime.fromISO(b.createdDate ?? '').valueOf() - DateTime.fromISO(a.createdDate ?? '').valueOf();
};

export const filterAndSortAlertsBySymbol = (
  alerts: Partial<PriceAlerts.Alert>[],
  symbol: StockSymbol,
): Partial<PriceAlerts.Alert>[] =>
  alerts.filter(alert => alert.symbol === symbol).sort(sortAlertsOnDateCreatedDescending);

export const negativeValueWarning = (loggingManager: LoggingManager) =>
  loggingManager.log(
    'warn',
    {
      category: '',
      message: 'The price must be greater than 0',
    },
    ['toast'],
  );
